import axios from 'axios';

//플래너 관련 store
const plannerStore = {
    state: {
      plannerInfo: [],
      plannerInfoOrigin: [],
  
    },
    mutations: {
      setPlannerInfo(state, data) {
        state.plannerInfo = data;
        state.plannerInfoOrigin = data;
      },
    },
    actions: {
      //플래너 정보 조회
      async getPlannerInfo(context) {
        axios.get(`/planner/list`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
          .then((res) => {
            context.commit('setPlannerInfo', res.data);
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '플래너 정보 조회'
                                          ,'alertContent': `오류 발생|${error}`});
          })
      },
  
      //플래너 정보 입력
      async insertPlannerInfo(context, data) {
        axios.post(`/planner/insert`, { 'name': data.name
                                        ,'regist_number': data.regist_number
                                        ,'phone': data.phone
                                        ,'address': data.address
                                        ,'insert_date': data.insert_date
                                        ,'insert_id': data.insert_id
                                      }, {
                                        headers: {
                                                    'Authorization': context.rootGetters.getCryptNum
                                        }
                                      })
          .then((res) => {
            if(res.data.result == 'success'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '플래너 정보 입력'
                                            ,'alertContent': res.data.message});
              context.dispatch('getPlannerInfo');
            }else if(res.data.result == 'fail'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '플래너 정보 입력'
                                            ,'alertContent': res.data.message});
            }else{
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '플래너 정보 입력'
                                            ,'alertContent': '입력 시 오류 발생|관리자 문의 필요'});
            }
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '플래너 관리'
                                          ,'alertContent': `오류 발생|${error}`});
          })
      },
  
      //플래너 정보 수정
      async modifyPlannerInfo(context, data) {
        axios.post(`/planner/update`, {  '_id': data._id
                                          ,'name': data.name
                                          ,'regist_number': data.regist_number
                                          ,'phone': data.phone
                                          ,'address': data.address
                                          ,'update_date': data.update_date
                                          ,'update_id': data.update_id
                                        }, {
                                          headers: {
                                                      'Authorization': context.rootGetters.getCryptNum
                                          }
                                        })
          .then((res) => {
            if(res.data.result == 'success'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '플래너 정보 수정'
                                            ,'alertContent': res.data.message});
              context.dispatch('getPlannerInfo');
            }
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '플래너 정보 수정'
                                          ,'alertContent': `오류 발생|${error}`});
            //console.log(error);
          })
      },
  
      //플래너 정보 삭제
      async deletePlannerInfo(context, data){
        axios.post(`/planner/delete`, {
          '_id': data.id
        }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          if(res.data.result == 'success'){
            context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '플래너 정보 삭제'
                                            ,'alertContent': res.data.message});
            context.dispatch('getPlannerInfo');
          }
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '플래너 정보 삭제'
                                          ,'alertContent': `오류 발생|${error}`});
        })
      },
    },
    getters: {
      
    }
  }

  export default plannerStore;